import { IShopWholesaler, POSTOnboardingLoginBody, POSTOnboardingLoginResponse } from '@cbgms/api'
import useQuery, { UseMutationOptions, useMutation } from '@cbgms/base/http/use-query'
import { getOnboardingWholesalersCacheKey } from 'app/auth/components/hooks/use-get-unfiltered-onboarding-wholesaler'
import { getOnboardingWholesalers, handleValidateWholesaler } from 'app/auth/state/actions'
import { useDispatch, useSelector } from 'react-redux'

// useGetOnboardingWholesalers return the wholesalers that are configured and active
// Warning: this is used during onboarding and also in logged in sessions. Which is why it takes a param
const useGetOnboardingWholesalers = (filterAvailableForPortal: boolean) => {
  const hasToken = useSelector(state => !!state.auth.tokens.IdToken)
  const dispatch = useDispatch()

  return useQuery<IShopWholesaler[], unknown>(
    getOnboardingWholesalersCacheKey(filterAvailableForPortal),
    async () => {
      const { Data } = await dispatch(getOnboardingWholesalers(filterAvailableForPortal))
      return Data ?? []
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      enabled: hasToken
    }
  )
}

// useValidateWholesalerCredentialsMutation
export const useValidateWholesalerCredentialsMutation = (
  options?: UseMutationOptions<POSTOnboardingLoginResponse, unknown, POSTOnboardingLoginBody, unknown> | undefined
) => {
  const dispatch = useDispatch()
  return useMutation(async (data: POSTOnboardingLoginBody) => {
    const { Data } = await dispatch(handleValidateWholesaler(data))
    return { Data } as POSTOnboardingLoginResponse
  }, options)
}

export default useGetOnboardingWholesalers
